module.exports = __webpack_public_path__ + "static/media/hero-bg.e1a551cd.png";